import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="space-y-4 text-center">
    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary">404</p>
    <h1 className="text-4xl text-slate-100">This page has moved outside the map.</h1>
    <p className="text-slate-400">Use the links below to jump back into the curated ecosystem.</p>
    <div className="flex flex-wrap justify-center gap-3 text-sm">
      <Link to="/" className="btn-primary">
        Homepage
      </Link>
      <Link to="/directory" className="btn-secondary">
        Directory
      </Link>
      <Link to="/map" className="btn-secondary">
        Global Map
      </Link>
    </div>
  </div>
);

export default NotFound;
